module.exports = __webpack_public_path__ + "img/price-quote5.7e46f2be.png";